import React , {useEffect, useState} from 'react'
import './DailyProblem.css'
import Problem from '../../ProblemLayout/Problem';
import { GettingDailyProblems } from '../../../Functions/CRUD/DailyProblem/DailyProblemHelper';
import LoadingPage from '../../../Error/LoadingPage/LoadingPage'

const DailyProblem = () => {
const [dailyProblem, setDailyProblem] = useState(null)
const [FoundStatus, setFoundStatus] = useState(null)

const fetchDailyProblems = async () => {
  const data = await GettingDailyProblems();

    if (data.message === "Found") {
      setFoundStatus(data.message);
      setDailyProblem(data.data);
    } else {
      setFoundStatus(data.message); // "No daily problem posted today"
      setDailyProblem(null);
    }
}

useEffect(() => {
  fetchDailyProblems()
}, [])




 if (!FoundStatus || (FoundStatus==="Found" && !dailyProblem)) {
    return <LoadingPage/>
}


  return (
    <div className="DailyProblemContainer">
        <h1>🧠 Problem of the Day</h1>
      <p className="Purpose">
        <b>Puropose : </b>Sharpen your skills with a carefully selected daily challenge! Each day, we bring you a new math problem—from classic proofs to tricky puzzles—to test your creativity and deepen your understanding. Whether you're preparing for math competitions or just love solving problems, this is your daily dose of brain food. Ready to take it on?
      </p>


{ FoundStatus==="Found" ?
      <Problem problem={dailyProblem}/> :
      <p className='NoProblem'>No problem is posted for today ....</p>
}

      {/* Couldn't solve yesterday’s Daily Problem? Don’t worry — we’ve got you covered! Take a quick sneak peek at the challenge and see how others approached it. Whether you missed it or just want to sharpen your problem-solving skills, it’s never too late to dive in.

      <Problem problem={dailyProblems.yesterday} PassDue={true}/> */}

      <div className="Suggesting-Problem">
<h1>💡 Got a Brilliant Problem?</h1>
      <p>If you have a mathematical gem you'd like to share, don’t hesitate to enlighten us!
We're always open to interesting, original, or classic problems to feature in our weekly challenges. Whether it's Number Theory, Geometry, Algebra, or Combinatorics — your suggestion could be next week's spotlight!
<br />
📬 Send your ideas via our Instagram page @mathtounsi.
Let's build this mathematical journey together!</p>
      </div>

    </div>
  );

}

export default DailyProblem
